import { listAssessmentEvents } from 'graphql/operations';

export const initLocalCache = cache => {
  cache.writeQuery({
    query: listAssessmentEvents,
    data: {
      listAssessmentEvents: []
    }
  });
};

export default {
  initLocalCache
};
